import { reset, initialize } from 'redux-form';
import PasswordService from '../../services/PasswordService';
import MyAccountActionType from '../../common/MyAccountActionType';

const submitForgotPassword = email =>
  dispatch => PasswordService.forgotPassword(email).then(
    () => {
      dispatch(reset('forgotPassword'));
      dispatch(initialize({ email: '' }));
    },
    (err) => {
      throw err;
    },
  );

const submitResetPassword = (password, token) =>
  dispatch => PasswordService.resetPassword(password, token).then(
    () => {
      dispatch({ type: MyAccountActionType.STORE_RESET_PASSWORD_SUCCESS });
    },
    (err) => {
      throw err;
    }
  );

const verifyToken = token =>
  () => PasswordService.verifyToken(token).then(
    response => response,
    (err) => {
      throw err;
    }
  );

const PasswordAction = {
  verifyToken,
  submitForgotPassword,
  submitResetPassword
};

export default PasswordAction;



/** WEBPACK FOOTER **
 ** ./src/redux/actions/PasswordAction.js
 **/